const User = ({ ...props }) => {
    return (
        <svg
            width="15"
            height="18"
            viewBox="0 0 15 18"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                id="Symbols"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="d/header.utility"
                    transform="translate(-99.000000, 0.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                    stroke="currentColor"
                    strokeWidth="0.25"
                >
                    <path
                        d="M113.313008,17.0246805 C113.313008,17.3397907 113.057561,17.595238 112.742451,17.595238 C112.42734,17.595238 112.171893,17.3397907 112.171893,17.0246805 C112.171893,13.9786152 109.702569,11.5092915 106.656504,11.5092915 C103.610439,11.5092915 101.141115,13.9786152 101.141115,17.0246805 C101.141115,17.3397907 100.885668,17.595238 100.570557,17.595238 C100.255447,17.595238 100,17.3397907 100,17.0246805 C100,13.3483949 102.980218,10.3681765 106.656504,10.3681765 C110.33279,10.3681765 113.313008,13.3483949 113.313008,17.0246805 Z M106.656504,8.98780483 C104.450733,8.98780483 102.662602,7.19967382 102.662602,4.99390241 C102.662602,2.78813101 104.450733,1 106.656504,1 C108.862275,1 110.650406,2.78813101 110.650406,4.99390241 C110.650406,7.19967382 108.862275,8.98780483 106.656504,8.98780483 Z M106.656504,7.84668985 C108.232055,7.84668985 109.509291,6.5694534 109.509291,4.99390241 C109.509291,3.41835143 108.232055,2.14111498 106.656504,2.14111498 C105.080953,2.14111498 103.803717,3.41835143 103.803717,4.99390241 C103.803717,6.5694534 105.080953,7.84668985 106.656504,7.84668985 Z"
                        id="Shape"
                    />
                </g>
            </g>
        </svg>
    )
}

export default User
